export default __webpack_public_path__ + "static/media/Incredible-India.63904d46.svg";